<template>
  <div>
    <b-card header="Opciones de Filtro" class="card-filter">
      <b-btn class="filter-collapse" 
          variant="primary" 
          size="sm"
          @click.prevent="showOpcionesFiltro= !showOpcionesFiltro">
        <i :class="showOpcionesFiltro ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="filtro" class="mt-2" v-model="showOpcionesFiltro">
        <b-form>
          <b-form-group
            label="Nombre"
            label-for="nombre"
            :label-cols="labelCols"
            description="Filtra por nombre y apellido de la persona"
            horizontal>
            <b-form-input 
              id="nombre" 
              v-model="filtro.nombre" 
              class="text-upper"
              type="text">
            </b-form-input>
          </b-form-group>

          <b-form-group
            v-if="documentoNumeroHabilitado"
            label="Nro. Documento"
            label-for="documentoNumero"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              id="documentoNumero" 
              v-model="filtro.documentoNumero" 
              class="text-upper"
              type="text">
            </b-form-input>
          </b-form-group>

          <b-form-group
            v-if="emailHabilitado"
            label="Email"
            label-for="email"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              id="email" 
              v-model="filtro.email" 
              type="text">
            </b-form-input>
          </b-form-group>

          <b-form-group
            v-if="numeroCelularHabilitado"
            label="Nro. Celular"
            label-for="numeroCelular"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              id="numeroCelular" 
              v-model="filtro.numeroCelular" 
              class="text-upper"
              type="text">
            </b-form-input>
          </b-form-group>

          <b-form-group
            v-if="negocioHabilitado"
            label="Negocio"
            label-for="negocio"
            description="Filtra por nombre comercial y/o razón social del negocio"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              id="negocio" 
              v-model="filtro.negocio" 
              class="text-upper"
              type="text">
            </b-form-input>
          </b-form-group>

          <b-form-group
            v-if="cuitNegocioHabilitado"
            label="CUIT"
            label-for="cuitNegocio"
            description="Filtra por el CUIT del negocio"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              id="cuitNegocio" 
              v-model="filtro.cuitNegocio" 
              class="text-upper"
              type="text">
            </b-form-input>
          </b-form-group>

          <b-form-group
            v-if="codigoPromocionHabilitado"
            label="Cod. Promoción"
            label-for="codigoPromocion"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              id="codigoPromocion" 
              v-model="filtro.codigoPromocion" 
              class="text-upper"
              type="text">
            </b-form-input>
          </b-form-group>

          <b-form-group
            v-if="numeroClienteHabilitado"
            label="Nro. Cliente"
            label-for="numeroCliente"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              id="numeroCliente" 
              v-model="filtro.numeroCliente" 
              class="text-upper"
              type="text">
            </b-form-input>
          </b-form-group>
        </b-form>

        <!-- <div class="footer">
          <b-button size="sm" variant="primary" class="footer-button"
            @click.prevent="filtrar">Filtrar</b-button>
          <b-button size="sm" variant="primary" class="footer-button" 
            @click.prevent="limpiarFiltro">Limpiar</b-button>
        </div> -->
      </b-collapse>

      <div slot="footer" v-if="showOpcionesFiltro">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="filtrar">Filtrar</b-button>
        <b-button size="sm" variant="primary" class="footer-button" 
          @click.prevent="limpiarFiltro">Limpiar</b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    nombre: {
      type: String,
      default: ''
    },
    documentoNumero: {
      type: String,
      default: ''
    },
    documentoNumeroHabilitado: {
      type: Boolean,
      default: false
    },
    email: {
      type: String,
      default: ''
    },
    emailHabilitado: {
      type: Boolean,
      default: false
    },
    numeroCelular: {
      type: String,
      default: ''
    },
    numeroCelularHabilitado: {
      type: Boolean,
      default: false
    },
    negocio: {
      type: String,
      default: ''
    },
    negocioHabilitado: {
      type: Boolean,
      default: false
    },
    cuitNegocio: {
      type: String,
      default: ''
    },
    cuitNegocioHabilitado: {
      type: Boolean,
      default: false
    },
    codigoPromocion: {
      type: String,
      default: ''
    },
    codigoPromocionHabilitado: {
      type: Boolean,
      default: false
    },
    numeroCliente: {
      type: String,
      default: ''
    },
    numeroClienteHabilitado: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      filtro: {
        nombre: '',
        documentoNumero: '',
        email: '',
        numeroCelular: '',
        negocio: '',
        cuitNegocio: '',
        codigoPromocion: '',
        numeroCliente: ''
      },
      showOpcionesFiltro: Boolean(false),
      labelCols: 2
    }
  },
  created() {
      this.filtro.nombre = this.nombre;
      this.filtro.documentoNumero = this.documentoNumero;
      this.filtro.email = this.email;
      this.filtro.numeroCelular = this.numeroCelular;
      this.filtro.negocio = this.negocio;
      this.filtro.cuitNegocio = this.cuitNegocio;
      this.filtro.codigoPromocion = this.codigoPromocion;
      this.filtro.numeroCliente = this.numeroCliente;
  },
  computed: {
  },     
  methods: {
    filtrar() {
      this.$emit('filtrar', this.filtro);
    },
    limpiarFiltro() {
      this.filtro.nombre = '';
      this.filtro.documentoNumero = '';
      this.filtro.email = '';
      this.filtro.numeroCelular = '';
      this.filtro.negocio = '';
      this.filtro.cuitNegocio = '';
      this.filtro.codigoPromocion = '';
      this.filtro.numeroCliente = '';
    },
  },
}
</script>

<style>
</style>
